// extracted by mini-css-extract-plugin
export default {"trouble_area":"Trouble_trouble_area__QNP5h","contents":"Trouble_contents__0+tmx","vanta":"Trouble_vanta__AxkU9"};